export default __webpack_public_path__ + "static/media/aplicativo-dashboard.c418529a.webp";